import React, { FC } from 'react';
import Link from 'next/link';
import { defineMessages, useIntl } from 'react-intl';
import { ActivityStatisticsCard } from 'src/apps/Activities/ActivityStatisticsCard';
import { ROUTES } from 'src/constants/routes.const';
import useSafePush from 'src/hooks/useSafePush';
import { Icon } from 'src/components';
import { getAnalyticsLanguageInfo } from 'src/utils/analytics/getAnalyticsLanguageInfo';
import { getAnalyticsUserInfo } from 'src/utils/analytics/getAnalyticsUserInfo';
import { useUserContext } from 'src/context/user';
import { useRandomActivity } from './useRandomActivity';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'myActivities_screenTitle' },
  intervalSuffix: { id: 'homeScreen_myActivities_widget_statDescription_7days' },
});

const INTERVAL_LENGTH_DAYS = 7;

export const MyActivitiesDashboardCard: FC = () => {
  const intl = useIntl();
  const { safePush } = useSafePush();
  const { user } = useUserContext();
  const randomActivity = useRandomActivity(INTERVAL_LENGTH_DAYS);
  const handleClick = () => {
    window.dataLayer.push({
      event: 'click_cta',
      action: 'exp_20250326_my_activities',
      page_screen_type: window.location.pathname,
      page_screen_name: window.location.pathname,
      click_area: 'My Activities Dashboard Card',
      click_path: 'My Activities Dashboard Card',
      ...getAnalyticsLanguageInfo(intl),
      ...getAnalyticsUserInfo(user),
    });
    void safePush(ROUTES.myActivities);
  };

  return (
    <S.CardWrapper>
      <S.CardOverlay data-testid="home_my_activities_widget" onClick={handleClick} />
      <S.Header onClick={handleClick}>
        <Icon name="statistics" />
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        <Link href={ROUTES.myActivities} passHref legacyBehavior>
          <S.ArrowButton>
            <Icon name="displayRight" />
          </S.ArrowButton>
        </Link>
      </S.Header>
      {randomActivity && (
        <ActivityStatisticsCard
          title={`${intl.formatMessage(randomActivity.labelMessage)} ${intl.formatMessage(msgs.intervalSuffix)}`}
          value={randomActivity.stat}
          difference={randomActivity.statDifference}
          type={randomActivity.type}
        />
      )}
    </S.CardWrapper>
  );
};
